/**
 * Наблюдение за прогоном предложения.
 *
 * Прогон существует ради одного слова, поэтому его ошибки относятся к этому
 * слову: считать посимвольную привязку внутри предложения нельзя — слово
 * стоит в тексте в своей форме, и её границы не совпадают с начальной.
 * Предложение переноса, ни к какому слову не привязанное, статистику не
 * меняет вовсе.
 */

import type { KeystrokeEvent, TypingError } from '@type2x/shared-contracts';
import { observeRun, type RunObservation } from '@type2x/typing-engine';

import type { SentenceDrill } from '../contracts/sentences.js';

/** Собирает наблюдение по прогону предложения. */
export function observeSentence(
  drill: SentenceDrill,
  events: readonly KeystrokeEvent[],
  errors: readonly TypingError[],
): RunObservation {
  const attempts = drill.word === null ? 0 : [...drill.word].length;
  return observeRun(attempts, events, errors);
}
